import React, { useState } from 'react';
import SchemaDiagram from '../components/labs/SchemaDiagram';
import AuthRequiredModal from '../components/dialogs/AuthRequiredModal';
import { Mail } from 'lucide-react';

const LabsLoginPage: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [userEmail, setUserEmail] = useState('');

  const handleLoginClick = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = (sentEmail?: string) => {
    setIsModalOpen(false);
    if (sentEmail) {
      setEmailSent(true);
      setUserEmail(sentEmail);
      // Don't redirect to Labs here - stay on the login page until authenticated
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex flex-col items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl w-full space-y-8 text-center">
        {emailSent ? (
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-8 max-w-md mx-auto">
            <div className="text-center">
              <Mail className="mx-auto h-12 w-12 text-blue-600 dark:text-blue-500" />
              <h2 className="mt-4 text-2xl font-semibold text-gray-900 dark:text-white">
                Check Your Email!
              </h2>
              <p className="mt-4 text-sm text-gray-600 dark:text-gray-300">
                We've sent a magic link to <strong>{userEmail}</strong>. Click the
                link to sign in.
              </p>
              <button
                onClick={() => setEmailSent(false)}
                className="mt-6 inline-flex items-center px-4 py-2 text-sm font-medium text-blue-600 dark:text-blue-500 hover:text-blue-500 dark:hover:text-blue-400"
              >
                Use a different email
              </button>
            </div>
          </div>
        ) : (
          <>
            <div>
              <h1 className="text-4xl font-extrabold text-gray-900 dark:text-white">
                🧪 MetaRouter Labs Login Required
              </h1>
              <p className="mt-6 text-lg text-gray-600 dark:text-gray-300">
                Welcome to Labs — our playground for wild ideas, rapid developement, and UI + AI experiments that might (or might not) make it into real products. Think of it as R&D with fewer rules.
              </p>
              <p className="mt-4 text-lg text-gray-600 dark:text-gray-300">
                You'll need to log in with your @metarouter.io email to get in.
              </p>
            </div>

            <div className="mt-8">
              <button
                onClick={handleLoginClick}
                className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              >
                Log in with @metarouter.io
              </button>
            </div>

            <div className="mt-10">
              <SchemaDiagram />
            </div>
          </>
        )}
      </div>

      {isModalOpen && <AuthRequiredModal onClose={(email) => handleCloseModal(email)} />}
    </div>
  );
};

export default LabsLoginPage;
